export const years: TableModule = {
    name: "years",
    route: "spa.basedata.years",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "id",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "is_active",
            sortable: true,
        },
        {
            name: "is_visible",
            sortable: true,
        },
        {
            name: "process_creation_enabled_areas",
        },
        {
            name: "total_funding",
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            name: "years.create",
            isCreateAction: true,
            ability: [
                "create",
                "years"
            ]
        }
    ]
}